import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  closeModalDialog,
  showSnackNotificationAction,
} from "../../../../../actions/layoutActions";
import { setReload } from "../../../../../actions/dataComponentActions";
import { getDataComponent } from "../../../../../reducers/dataComponentReducer";
import { convertServerErrorToFormikErrors } from "../../../../../utils/formValidationUtils";
import propTypes from "../../../../../constants/propTypes";
import { scaleDataComponentId } from "./ScaleContainer";

/**
 * Create and edit share the same feedback: notify, reload the grid and close
 * the modal on success, surface the server error on the name field otherwise.
 * The only difference is which request hook reports it and what the message says.
 */
export const useScaleFormFeedback = (
  dataComponent,
  useProcessRequests,
  { successMessage, showSnackNotificationAction, setReload, closeModalDialog }
) => {
  useProcessRequests(dataComponent, {
    onSuccess: () => {
      showSnackNotificationAction(successMessage);
      setReload(scaleDataComponentId, true);
      closeModalDialog();
    },
    onError: error => {
      const convertedError = convertServerErrorToFormikErrors(error);
      showSnackNotificationAction(convertedError.name);
    },
  });
};

export const scaleFormPropTypes = {
  dataComponent: propTypes.dataComponent,
  showSnackNotificationAction: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
};

/**
 * Connects a scale form container to its data component, adding the request
 * action it submits with on top of the feedback actions every form needs.
 */
export const connectScaleForm = (Container, submitAction) =>
  connect(
    state => ({
      dataComponent: getDataComponent(scaleDataComponentId, state),
    }),
    {
      showSnackNotificationAction,
      setReload,
      closeModalDialog,
      ...submitAction,
    }
  )(Container);
